import { withInstall } from '@sgui-plus/utils/with-install'

import ConfigProvider from './src/config-provider'

export const SgConfigProvider = withInstall(ConfigProvider)
export default SgConfigProvider

export * from './src/config-provider'
export * from './src/constants'
